import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";

const TimePicker = ({ label, name, value, onChange, error }) => {
  const hours = Array.from({ length: 12 }, (_, i) => i + 1); // 1 to 12
  const minutes = Array.from({ length: 60 }, (_, i) =>
    i.toString().padStart(2, "0")
  );
  const ampmOptions = ["AM", "PM"];

  const [selectedHour, setSelectedHour] = useState("");
  const [selectedMinute, setSelectedMinute] = useState("00");
  const [selectedAmPm, setSelectedAmPm] = useState("AM");

  useEffect(() => {
    if (value) {
      const [time, ampm] = value.split(" ");
      const [hour, minute] = time.split(":");
      setSelectedHour(hour);
      setSelectedMinute(minute);
      setSelectedAmPm(ampm);
    }
  }, [value]);

  useEffect(() => {
    if (selectedHour && selectedMinute && selectedAmPm) {
      onChange(`${selectedHour}:${selectedMinute} ${selectedAmPm}`);
    } else {
      onChange(null);
    }
  }, [selectedHour, selectedMinute, selectedAmPm]);

  return (
    <Form.Group controlId={name}>
      <Form.Label>{label}</Form.Label>
      <div style={{ display: "flex", gap: "10px" }}>
        <Form.Control
          as="select"
          value={selectedHour}
          onChange={(e) => setSelectedHour(e.target.value)}
        >
          <option value="">Hour</option>
          {hours.map((hour) => (
            <option key={hour} value={hour}>
              {hour}
            </option>
          ))}
        </Form.Control>
        <Form.Control
          as="select"
          value={selectedMinute}
          onChange={(e) => setSelectedMinute(e.target.value)}
        >
          <option value="">Minute</option>
          {minutes.map((minute) => (
            <option key={minute} value={minute}>
              {minute}
            </option>
          ))}
        </Form.Control>
        <Form.Control
          as="select"
          value={selectedAmPm}
          onChange={(e) => setSelectedAmPm(e.target.value)}
        >
          <option value="">AM/PM</option>
          {ampmOptions.map((ampm) => (
            <option key={ampm} value={ampm}>
              {ampm}
            </option>
          ))}
        </Form.Control>
      </div>
      {error && <span className="text-danger">{error}</span>}
    </Form.Group>
  );
};

export default TimePicker;
